import { createContext, Dispatch, ReactNode, useContext, useState } from 'react'

type TemplateStep = 'templates' | 'social-profile' | 'introduction' | 'contact-info'

export const CurrentStepName = {
  0: 'social-profile',
  1: 'introduction',
  2: 'contact-info',
  3: 'templates',
} as { [x: number]: TemplateStep }

type TemplatesGuestProperties = {
  currentStep: number
  currentStepName: TemplateStep
}

const defaultTemplateGuestProperties: TemplatesGuestProperties = {
  currentStep: 0,
  currentStepName: 'social-profile',
}

const MainAppContext = createContext<TemplatesGuestProperties>(defaultTemplateGuestProperties)
const SetMainAppContext = createContext<Dispatch<TemplatesGuestProperties>>(() => {})

type TemplateSignInProvider = {
  children: ReactNode
}

const TemplateGuestProvider = ({ children }: TemplateSignInProvider) => {
  const [appProperties, setAppProperties] = useState<TemplatesGuestProperties>({
    ...defaultTemplateGuestProperties,
  })

  return (
    <MainAppContext.Provider value={appProperties}>
      <SetMainAppContext.Provider value={setAppProperties}>{children}</SetMainAppContext.Provider>
    </MainAppContext.Provider>
  )
}

export const useMainAppContext = () => {
  return useContext(MainAppContext)
}

export const useSetMainProperties = () => {
  const setMainProperties = useContext(SetMainAppContext)
  return (value: TemplatesGuestProperties) => {
    setMainProperties(value)
  }
}

export const useGetCurrentStep = () => {
  const context = useContext(MainAppContext)
  return context.currentStep
}

export const useSetCurrentStep = () => {
  const properties = useMainAppContext()
  const setMainProperties = useContext(SetMainAppContext)
  return (step: number) => {
    setMainProperties({ ...properties, currentStep: step })
  }
}

export default TemplateGuestProvider
